



















































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { getCurrentEmployee, getCurrentUserId, isRoot } from "@/plugins/roles";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import company, { CompanyListParams } from "@/getinfo-api/company";
import protocols, {
  EducationProtocolListParams
} from "@/getinfo-api/education-protocol";
import { CompaniesList as ICompaniesList } from "@/api/models/companies-list";
import { User as IUser } from "@/api/models/user";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import { EmployeeEdit as IEmployeeEdit } from "@/api/models/employee-edit";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import UserDiskSpace from "@/components/user/UserDiskSpace.vue";
import api, { fileApi } from "@/getinfo-api";
import {
  bookkeepingModule,
  learningDocumentsModule,
  studentDocumentModule,
  consentModule
} from "@/plugins/modules-detect";
import UserAvatar from "@/components/user/UserAvatar.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CFileManager from "@/components/fileManager/CFileManager.vue";
import Doughnut from "@/components/companies/Doughnut.vue";
import { DiskList as IDiskList } from "@/api-v2/files/models";
import CustomTable from "@/components/form/CustomTable.vue";
import EducationProtocolTableItem from "@/components/education/EducationProtocolTableItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import UserFilesFromDocuments from "@/components/user/UserFilesFromDocuments.vue";

@Component({
  components: {
    UserFilesFromDocuments,
    CustomButton,
    EducationProtocolTableItem,
    CustomTable,
    Doughnut,
    CFileManager,
    TextField,
    CBlock,
    UserAvatar,
    UserDiskSpace
  }
})
export default class UserProfileView extends Vue {
  @Prop() user!: IUser;
  @Prop() documentInfo!: IUserDocumentInfo;
  protocols: any[] = [];
  userCompanies!: ICompaniesList;
  rolesInCompany: Array<string> = [];
  rolesFreeze: Array<string> = [];
  employeeId: string | undefined = undefined;
  employeeWithCompany: any = [];
  userDisk!: any;

  data() {
    return {
      userDisk: undefined,
      userCompanies: undefined,
      rolesInCompany: undefined,
      userCanEditProfile: undefined
    };
  }

  get isConsentModuleEnabled() {
    return consentModule();
  }

  get currentUserId() {
    return getCurrentUserId();
  }

  get isStudentDocumentModule() {
    return studentDocumentModule();
  }

  getFileSizeFormatter(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  getFileSpace() {
    fileApi.DiskApi.my(0, 200).then((res: { data: IDiskList }) => {
      this.userDisk = res.data.items;
    });
  }

  // getFileSpace() {
  //   if (this.user) {
  //     const params: DiskApiListParams = {
  //       usersIds: [this.user.id]
  //     };
  //
  //     fileManagerDisks(params).then((res: { data: IDiskList }) => {
  //       this.userDisk = res.data.items;
  //     });
  //   }
  // }

  get showEducationPart() {
    return !!(
      this.documentInfo &&
      (this.documentInfo.education ||
        this.documentInfo.educationNumber ||
        this.documentInfo.educationInstitution ||
        this.documentInfo.educationSurname ||
        this.documentInfo.educationRegistrationNumber ||
        this.documentInfo.educationDate ||
        this.documentInfo.educationSeries)
    );
  }

  get userIsEmployeeSelectedCompany() {
    let result = false;
    if (this.userCompanies) {
      this.userCompanies.companies.forEach(company => {
        if (company.id === this.selectedCompany.id) {
          this.getUserRoles(this.selectedCompany.id);
          result = true;
        } else {
          this.rolesInCompany = [];
        }
      });
    }
    return result;
  }

  get bookkeepingBundle() {
    return bookkeepingModule();
  }

  get documentModule() {
    return bookkeepingModule() || learningDocumentsModule();
  }

  getUserRoles(companyId: string) {
    let params: EmployeeListParams = {
      id: companyId,
      userIds: [this.user.id]
    };

    employee(params)
      .then((res: { data: IEmployeesList2 }) => {
        this.employeeId = res.data.employees[0].id;
        this.rolesInCompany = res.data.employees[0].roles;
        this.rolesFreeze = this.rolesInCompany;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get root() {
    return isRoot();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  changeRole() {
    let deleteArray: Array<string> = [];
    let newArray: Array<string> = [];

    this.rolesFreeze.forEach(element => {
      if (!this.rolesInCompany.includes(element)) {
        deleteArray.push(element);
      }
    });

    this.rolesInCompany.forEach(element => {
      if (!this.rolesFreeze.includes(element)) {
        newArray.push(element);
      }
    });

    if (this.employeeId) {
      let params: IEmployeeEdit = {
        removeRoles: deleteArray.length > 0 ? deleteArray : undefined,
        roles: newArray.length > 0 ? newArray : undefined
      };
      api.EmployeeApi.edit(
        this.selectedCompany.id,
        this.employeeId,
        params
      ).then(() => {
        this.getUserRoles(this.selectedCompany.id);
      });
    }
  }

  getCompany() {
    let params: CompanyListParams = {
      employeesIds: [this.user.id]
    };
    company(params)
      .then((res: { data: ICompaniesList }) => {
        this.userCompanies = res.data;
        if (this.userCompanies?.companies.length) {
          this.getRolesInCompany();
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  getRolesInCompany() {
    this.userCompanies.companies.forEach(el => {
      const param: EmployeeListParams = {
        id: el.id,
        userIds: [this.user.id]
      };
      employee(param).then((response: { data: IEmployeesList2 }) => {
        const obj = {
          company: el,
          employee: response.data.employees[0]
        };
        this.employeeWithCompany.push(obj);
      });
    });
  }

  getRoles(role: string) {
    let formattedRole = "";
    if (role === "content_manager")
      formattedRole = this.$tc(this.$translate.Teacher);
    if (role === "learning_request_manager")
      formattedRole = this.$tc(this.$translate.LearningRequestManager);
    if (role === "document_manager")
      formattedRole = this.$tc(this.$translate.Accountant);
    return formattedRole;
  }

  gender() {
    switch (this.user.gender) {
      case 1:
        return this.$tc(this.$translate.Male);
      case 0:
        return this.$tc(this.$translate.Female);
      default:
        return this.$tc(this.$translate.NotSelected);
    }
  }

  getEducationProtocol() {
    let params: EducationProtocolListParams = {
      listenerUserIds: [this.user.id],
      sort: "updatedAt",
      order: "DESC",
      limit: 999
    };
    protocols(params).then(res => {
      this.protocols = res.data.items;
    });
  }

  mounted() {
    this.getFileSpace();
    this.getCompany();
    this.getEducationProtocol();
  }
}
